import React from 'react'
import { Skeleton } from '@mantine/core'

const RatingShowsSkeleton = () => {
  return (
    <div className='flex flex-col gap-4 mt-10 mb-10'>
      <div className='flex flex-wrap gap-8 my-2 w-[354px] md:w-full'>
        {Array.from({ length: 12 }).map((_, index) => (
          <div key={index} className='w-full md:w-[48%]'>
            <div
              className='
                   bg-white rounded-lg p-4 shadow-lg
                   w-full min-w-[250px] max-w-full
                   md:w-full
                 '
            >
              {/* Top Row */}
              <div className='flex gap-4 mb-3'>
                {/* Avatar */}
                <Skeleton height={48} width={48} circle />

                {/* Name + Rating */}
                <div className='flex-1 flex flex-col sm:flex-row sm:items-center sm:justify-between'>
                  <div className='flex-1'>
                    <Skeleton height={16} width='45%' className='mb-1' />
                    <Skeleton height={14} width='35%' />
                  </div>

                  <div className='flex items-center gap-1 mt-1 sm:mt-0'>
                    <Skeleton height={20} width={80} />
                    <Skeleton height={16} width={25} />
                  </div>
                </div>
              </div>

              {/* Review Text */}
              <div className='space-y-2'>
                <Skeleton height={14} width='100%' />
                <Skeleton height={14} width='95%' />
                <Skeleton height={14} width='75%' />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RatingShowsSkeleton
